export abstract class ClientRequestBase {}
